import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomerService } from 'src/app/services/customer.service';

@Component({
  selector: 'app-customer-requested-fields',
  templateUrl: './customer-requested-fields.component.html',
  styleUrls: ['./customer-requested-fields.component.scss']
})
export class CustomerRequestedFieldsComponent implements OnInit {

  currentDetailsForm: FormGroup;
  newDetailsForm: FormGroup;
  customerId: any;
  isLoadingoverlay: boolean = false;
  constructor(
    private customerService: CustomerService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private activeModal: NgbModal
  ) {
    this.activatedRoute.paramMap.subscribe(params => {
      const id = params['params']['id'];
      this.customerId = id;
      if (id) {
        this.getDetails(id);
      }
    });
  }

  ngOnInit(): void {
    this.currentDetailsForm = this.formBuilder.group({
      customerName: [''],
      email: [''],
      secondaryEmail: [''],
      phoneNumber: [''],
      dba: [''],
      address: [''],
      country: [''],
      state: [''],
      city: [''],
      postalCode: ['']
    });

    this.newDetailsForm = this.formBuilder.group({
      customerName: [''],
      email: [''],
      secondaryEmail: [''],
      phoneNumber: [''],
      dba: [''],
      address: [''],
      country: [''],
      state: [''],
      city: [''],
      postalCode: ['']
    });
  }

  getDetails(id) {
    this.customerService.getUpdatesCustomerDetails(id).subscribe((res: any) => {
      if (res && res['result'] && res['result']['currentDetails']) {
        this.currentDetailsForm.patchValue(res['result']['currentDetails']);
      }

      if (res && res['result'] && res['result']['newDetails']) {
        this.newDetailsForm.patchValue(res['result']['newDetails']);
      }

      this.currentDetailsForm.disable();
      this.newDetailsForm.disable();
    });
  }

  onApproveModal() {
    const modalRef = this.activeModal.open(CustomModalComponent, { centered: true, ariaLabelledBy: 'customModalTitle' });
    modalRef.componentInstance.title = "Approve Request";
    modalRef.componentInstance.description = "Are you sure you want to approve the changes?";
    modalRef.componentInstance.infoIcon = "./assets/img/ExclamationCircle.png";
    modalRef.componentInstance.btnText = "Yes, Approve";
    modalRef.result.then(
      (data: any) => {
        if (data == "ok") {
          this.approve();
        }
      },
      (reason: any) => {
        console.log(reason);
      }
    );
  }

  onDenyModal() {
    const modalRef = this.activeModal.open(CustomModalComponent, { centered: true, ariaLabelledBy: 'customModalTitle' });
    modalRef.componentInstance.title = "Deny Request";
    modalRef.componentInstance.description = "Are you sure you want to deny the changes?";
    modalRef.componentInstance.infoIcon = "./assets/img/ExclamationCircle.png";
    modalRef.componentInstance.btnText = "Yes, Deny";
    modalRef.result.then(
      (data: any) => {
        if (data == "ok") {
          this.deny();
        }
      },
      (reason: any) => {
        console.log(reason);
      }
    );
  }

  approve() {
    this.isLoadingoverlay = true;
    this.customerService
      .approveCustomerDetails(this.customerId)
      .subscribe((res: any) => {
        this.isLoadingoverlay = false;
        if (res && res['status'] == "Success") {
          alert(res['message']);
          this.router.navigateByUrl('/admin/customer-update-request');
        } else {
          alert(res['message'] || "Something went wrong! Please try again.");
        }
      });
  }

  deny() {
    this.isLoadingoverlay = true;
    this.customerService
      .denyCustomerDetails(this.customerId)
      .subscribe((res: any) => {
        this.isLoadingoverlay = false;
        if (res && res['status'] == "Success") {
          alert(res['message']);
          this.router.navigateByUrl('/admin/customer-update-request');
        } else {
          alert(res['message'] || "Something went wrong! Please try again.");
        }
      });
  }

  compareFields(field) {
    if (this.newDetailsForm.get(field).value != this.currentDetailsForm.get(field).value) {
      return true;
    } else {
      return false;
    }
  }
}
